import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const cacheVersionInterceptor: HttpInterceptorFn = (req, next) => {
  // Agregar versión como query param para evitar cache
  const separator = req.url.includes('?') ? '&' : '?';
  const versionedUrl = `${req.url}${separator}_v=${environment.version}`;
  return next(req.clone({ url: versionedUrl }));
};
